import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import React, { useState } from "react";

function Menu() {
  const [text, setText] = useState(
    <a style={{ color: "#fff" }} className="tipo">
      Tipos de bots
    </a>
  );

  return (
    <Navbar bg="primary" expand="lg">
      <Container className="container-menu">
        <Navbar.Brand href="#home">
          <div className="logo-bot">
            <img
              src="Mini-Robot.png"
              alt="logo chat bot"
              width={60}
              className="logo-img"
            />
            <span>
              Auto<strong>Bot</strong>
            </span>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="navbar-collapse collapse"
        >
          <Nav className="me-auto">
            <Nav.Link href="#home" className="home">
              Home
            </Nav.Link>
            <Nav.Link href="#link" className="sobre">
              Sobre
            </Nav.Link>

            <span className="submenu1" style={{ color: "#fff" }}>
              <NavDropdown
                style={{ color: "#fff" }}
                id="basic-nav-dropdown"
                className="submenu"
                bg="promary"
                title={text}
                variant="dark"
              >
                <div className="sub-menu">
                  <NavDropdown.Item href="#cardbotao" className="sub-listas">
                    Com botão
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="#cardlista" className="sub-listas">
                    Com lista
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="#cardcompra" className="sub-listas">
                    Compras
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    href="#cardpersonalizado"
                    className="sub-listas"
                  >
                    Personalizado
                  </NavDropdown.Item>
                </div>
              </NavDropdown>
            </span>
            <Nav.Link href="#contato" className="contato">
              Contato
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Menu;
